module.exports = __webpack_public_path__ + "img/1.6b05ac78.png";